import BaseUIPGSelectorOnlyView from 'xui/modules/product/BaseUIPGSelectorOnlyView'

export default class PGSelectorOnlyView extends BaseUIPGSelectorOnlyView {
  static displayName = 'PGSelectorOnlyView'
}
